export default __webpack_public_path__ + "static/media/sound waves.f7dd5082.svg";